module.exports = __webpack_public_path__ + "static/media/3 05 Tulleord Vuks er feil.d6ac2d86.mp3";